module.exports = "\n    <div class=\"innerContainer\">\n        <h1>{{errorMessage}}</h1>\n    </div> \n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/okta-custom-callback/okta-custom-callback.component.html
// module id = ./src/app/components/okta-custom-callback/okta-custom-callback.component.html
// module chunks = main